import { GridRowClassNameParams } from '@mui/x-data-grid';
import { isBefore } from 'date-fns';

import { AdvancedInventoryFilterType } from 'constants/enums';
import { InventoryTreeNode } from 'types/customInventoryFilters.interface';

export const getRowClassName = ({ row }: GridRowClassNameParams) => {
  const today = new Date();

  if (row.expireDate) {
    const expireDate = new Date(row.expireDate);
    if (isBefore(expireDate, today)) {
      return 'inventory-expired';
    }
  }

  if (
    row.allOnHandPerLocation && row.locationLowInventoryThresholdBatch
    && row.allOnHandPerLocation <= row.locationLowInventoryThresholdBatch
  ) {
    return 'inventory-low';
  }

  return '';
};

export const getActiveFilters = (count: number, suffix: string) => (
  `${count} ${count === 1 ? 'Filter' : 'Filters'} ${suffix}`
);

export const countSimpleFilters = (filters: any) => (
  filters.reduce((count: number, { value }: { value: any }) => {
    if (Array.isArray(value)) {
      return count + value.length;
    }

    return value ? count + 1 : count;
  }, 0)
);

export const countAdvancedFilters = (node: InventoryTreeNode): number => {
  if (node.type === AdvancedInventoryFilterType.CONDITION) {
    return 1;
  }

  if (node.type === AdvancedInventoryFilterType.GROUP) {
    return (node.children || []).reduce((acc, child) => acc + countAdvancedFilters(child), 0);
  }

  return 0;
};
